import { createRequiredValidators } from "@xo/client-common";
import { Type12RichText } from "./Type12RichText";

export function createType12RichTextValidators() {
    return [
        ...createRequiredValidators<Type12RichText>(["simpleField", "validatedField"]),
    ];
}
